import React from 'react';

import TableRow from './TableRow';

const TableBody = (props) => {
    let oProfiles = props.perfiles.map(function (perfil) {
        if ((perfil.ProductoId == null) || (props.filter.product == 0) || (perfil.ProductoId == props.filter.product)) {
            return (
                <TableRow activate={props.filter.activate}
                    perfil={perfil}
                    funciones_tabla={props.funciones_tabla}
                    deleteFuncion={props.deleteFuncion}
                    addFuncion={props.addFuncion} />
            );
        }
    });

    return (
        <tbody>
            {oProfiles}
        </tbody>
    );
}

export default TableBody;